(function () {
    'use strict';
	
    angular.module('SMART2').service('scrollPosition', ['$filter', '$state', function ($filter, $state) {
    	var isEnabledScroll,
    		scrollValue = [];

    	this.setEnableScroll = function (enableScroll) {
    		isEnabledScroll = enableScroll
    	}

    	this.getEnableScroll = function () {
    		return isEnabledScroll;
    	}

		this.set = function (pos, currentUrl) {
			if (scrollValue.length === 0)
				scrollValue.push({ 'scroll': pos, 'currentUrl': currentUrl });
			else {
				var foundItem = $filter('filter')(scrollValue, { 'currentUrl': currentUrl }, true)[0];
				var foundItemIndex = scrollValue.indexOf(foundItem);
				if (foundItem) {
					scrollValue.splice(foundItemIndex, 1);
					scrollValue.push({ 'scroll': pos, 'currentUrl': currentUrl });
				}
				else
					scrollValue.push({ 'scroll': pos, 'currentUrl': currentUrl });
			}
		}

		this.get = function () {
			return scrollValue;
		}

		this.performScroll = function (staticValue, aSpeed, onComplete) {
			angular.element('body,html').animate({ scrollTop: staticValue }, 3500, 'linear');
		}

		this.scrollWitgetsection = function (config) {
		    var state = $state,
                scrollToconfig;
		    setTimeout(function () {
		        if (state.previous.scrollTo && state.previous.scrollTo.state === state.current.name) {
		            scrollToconfig = config.filter(function (c) { return state.previous.scrollTo.sectionId === c.sectionId });
		            var $cont = $('#' + scrollToconfig[0].sectionKey);
		            if ($cont.length && $cont.find('.collapsible-header').hasClass('active')) {
		                var displacementItem = $cont.offset().top - angular.element('#' + scrollToconfig[0].sectionKey.split('-section')[0] + '-sortable').offset().top;

		                displacementItem = displacementItem + 62;

		                angular.element('body,html').animate({
		                    scrollTop: displacementItem
		                }, "medium");
		            } else {
		                $cont.find('.collapsible-header').trigger('click');
		            }
		        }
		    }, 100);
		}
	}]);
})();